import React from "react";
import PropTypes from "prop-types";
import { Image } from "@learningblocks/shared-components";
import { TubeRotorIcon } from "../../Icons";

export function TubeRotor(props) {
  return (
    <Image className={props.className} src={TubeRotorIcon} alt="TubeRotor" />
  );
}

TubeRotor.propTypes = {
  /**
   * ClassName for component
   */
  className: PropTypes.string,
};

TubeRotor.defaultProps = {};
